/**
* @file Marquee we compare
*/

import Marquee from 'integration-common-files/src/js/02-molecules/marquee';

export default function loadMarquee(){
  // Marquee
  const marquee = document.querySelector('#marquee-we-compare');
  if(marquee) {
    new Marquee({
      selector: '#marquee-we-compare',
    })
  }
};

